import { CookieKeys } from '@/constants/commons'

export function useHasSmartBannerClosedCookie() {
  return useCookie<boolean>(CookieKeys.HAS_SMART_BANNER_CLOSED, {
    default: () => false,
  })
}
